var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.84C1 17.12 5.96 17.12 8.44 14.64C9.68 13.4 5.96 13.4 5.96 7.2C5.96 3.06708 7.61292 1 10.92 1C14.2271 1 15.88 3.06708 15.88 7.2C15.88 13.4 12.16 13.4 13.4 14.64C14.3995 15.6395 15.8019 16.2362 17.12 16.8359",
    stroke: "#0B1836",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3198 12.1602L23.3198 12.7113L23.3198 17.1202",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.04 12.1602L27.04 12.7113L27.04 17.1202",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7601 9.68018L29.9628 19.3289C29.9628 19.7297 29.7949 20.1141 29.4959 20.3975C29.1969 20.681 28.7914 20.8402 28.3685 20.8402H21.9914C21.5686 20.8402 21.1631 20.681 20.8641 20.3975C20.5651 20.1141 20.3971 19.7297 20.3971 19.3289L19.6001 9.68018H30.7601Z",
    stroke: "#0B1836",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0801 5.72021V6.20021C22.0801 6.7525 22.5278 7.20021 23.0801 7.20021H27.2801C27.8324 7.20021 28.2801 6.7525 28.2801 6.20022V5.72021C28.2801 5.16793 27.8324 4.72021 27.2801 4.72021H23.0801C22.5278 4.72021 22.0801 5.16793 22.0801 5.72021Z",
    stroke: "#0B1836",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3599 7.70019V9.1802C18.3599 9.45634 18.5837 9.6802 18.8599 9.6802H31.4999C31.776 9.6802 31.9999 9.45634 31.9999 9.1802V7.7002C31.9999 7.42405 31.776 7.2002 31.4999 7.2002H18.8599C18.5837 7.2002 18.3599 7.42405 18.3599 7.70019Z",
    stroke: "#0B1836",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.3d26af5916640f03633f78ad21d558d8.svg";
export { ForwardRef as ReactComponent };